"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteSystemEmail = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.WaysteSystemEmail = typebox_1.Type.Object({
    subject: typebox_1.Type.String(),
    preheader: typebox_1.Type.String(),
    hauler_name: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    email_body: typebox_1.Type.String(),
    hauler_email: typebox_1.Type.String(),
    hauler_logo: typebox_1.Type.String(),
});
//# sourceMappingURL=wayste-system-email.js.map